import { createReducer, getType } from 'typesafe-actions';
import { useApiQueryActions } from './actions';
export const INITIAL_STATE = {
    requestId: null,
    paramsId: null,
    loading: false,
    data: null,
    error: null
};
export const useApiQueryReducer = createReducer(INITIAL_STATE, {
    [getType(useApiQueryActions.newRequest)]: (prev, action) => {
        var _a, _b;
        if (!action.payload.paramsId) {
            return INITIAL_STATE;
        }
        if (action.payload.fetchPolicy === 'cache-only' &&
            action.payload.cachedData) {
            return Object.assign(Object.assign({}, INITIAL_STATE), { data: action.payload.cachedData });
        }
        return {
            requestId: action.payload.requestId,
            paramsId: action.payload.paramsId,
            loading: true,
            error: null,
            data: (_b = (_a = action.payload.initialData, (_a !== null && _a !== void 0 ? _a : action.payload.cachedData)), (_b !== null && _b !== void 0 ? _b : (action.payload.dontReinitialize ? prev.data : null)))
        };
    },
    [getType(useApiQueryActions.success)]: (prev, action) => {
        if (isLiveRequest(prev, action)) {
            return Object.assign(Object.assign({}, prev), { loading: false, data: action.payload.data, error: null });
        }
        return prev;
    },
    [getType(useApiQueryActions.failure)]: (prev, action) => {
        if (isLiveRequest(prev, action)) {
            return Object.assign(Object.assign({}, prev), { loading: false, data: null, error: action.payload.error });
        }
        return prev;
    },
    [getType(useApiQueryActions.replaceState)]: (_, action) => action.payload,
    [getType(useApiQueryActions.refetchRequest)]: (prev, action) => {
        // ensure that the refetch has the correct request params
        if (action.payload.paramsId === prev.paramsId) {
            return Object.assign(Object.assign({}, prev), { requestId: action.payload.requestId, paramsId: action.payload.paramsId, loading: true, data: action.payload.reinitialize ? null : prev.data });
        }
        return prev;
    },
    [getType(useApiQueryActions.setData)]: (prev, action) => {
        return Object.assign(Object.assign({}, prev), { data: typeof action.payload === 'function'
                ? action.payload(prev.data)
                : action.payload });
    }
});
/**
 * Ensures that the completed request was the last one that was called
 */
function isLiveRequest(prev, action) {
    return (action.payload.requestId === prev.requestId &&
        action.payload.paramsId === prev.paramsId);
}
//# sourceMappingURL=reducer.js.map